import { relationTypeOptions } from "../../../periodic-reviews-webapp/src/constants.ts";
import { PeriodicReviews } from "../../../periodic-reviews-webapp/src/types.ts";

export const addNewRelation = (
  relationNumber: string,
): PeriodicReviews.WebApp.FormData => {
  return [
    {
      id: `relation_${relationNumber}_header`,
      title: {
        en: `Relation ${relationNumber}`,
        es: `Relación ${relationNumber}`,
        nl: `Relatie ${relationNumber}`,
        fr: `Relation ${relationNumber}`,
        pt: `Relação ${relationNumber}`,
        it: `Relazione ${relationNumber}`,
        de: `Beziehung ${relationNumber}`,
        pl: `Relacja ${relationNumber}`,
        ro: `Relația ${relationNumber}`,
        gr: `Σχέση ${relationNumber}`,
        //TODO: add new language here
      },
      type: "subheader",
    },
    {
      id: `relation_${relationNumber}_delete`,
      title: {
        en: `Relation delete`,
      },
      value: relationNumber,
      type: "relationDelete",
    },
    {
      id: `relation_${relationNumber}_relation_type_updated`,
      title: {
        en: `Relation type`,
        es: `Tipo de relación`,
        nl: `Relatietype`,
        fr: `Type de relation`,
        pt: `Tipo de relação`,
        it: `Tipo di relazione`,
        de: `Beziehungstyp`,
        pl: `Typ relacji`,
        ro: `Tipul relației`,
        gr: `Τύπος σχέσης`,
        //TODO: add new language here
      },
      type: "select",
      options: relationTypeOptions,
    },
  ];
};
